import { LocationService, JobService, CachedLocationService } from '@services';
import { apiErrorHandler } from '@config/utils';
import utils from '@utils';
import Actions from '.';

/* ------------- Thunks actions ------------- */
export const getLocationsData = () => ((dispatch, getState) => {
	const {
		filters : {
			displayCount,
			pageNumber,
		},
	} = getState().locations;

	// Start loading animation
	dispatch(Actions.setLoading('data', true));

	LocationService.getAll({
		displayCount,
		pageNumber,
		minimalData : false,
	})
		.then(({ data : { Count, ItemList } }) => {
			// Deceive data
			dispatch(Actions.receiveData(ItemList, Count));

			// Stop loading animation
			dispatch(Actions.setLoading('data', false));
		})
		.catch(apiErrorHandler({
			dispatch,
			module   : 'locations',
			property : 'loading.data',
		}));
});

export const getLocationDetails = () => ((dispatch, getState) => {
	const {
		match : { params : { id } },
	} = getState().router;

	// Start loading animation
	dispatch(Actions.setLoading('data', true));

	LocationService.getById(id, { includeStats : true })
		.then(({ data }) => {
			// Receive Details
			dispatch(Actions.receiveDetails('data', data));

			// Stop loading animation
			dispatch(Actions.setLoading('data', false));
		})
		.catch(apiErrorHandler({
			dispatch,
			module       : 'locations',
			property     : 'loading.data',
			navigateBack : true,
		}));
});

export const getMinimalLocationsData = () => ((dispatch) => {
	// Start loading animation
	dispatch(Actions.setLoading('minimalData', true));

	CachedLocationService.getAllMinimalData({
		minimalData : true,
	})
		.then(({ data }) => {
			// Deceive data
			dispatch(Actions.receiveMinimalData(utils.processMinimalLocationsData(data)));
			// Stop loading animation
			dispatch(Actions.setLoading('minimalData', false));
		})
		.catch(apiErrorHandler({
			dispatch,
			module   : 'locations',
			property : 'loading.minimalData',
		}));
});

export const getJobsData = (section = 'jobHistory') => ((dispatch, getState) => {
	const {
		match : { params : { id : locationId } },
	} = getState().router;
	const {
		details : {
			activeJobs,
			jobHistory,
		},
	} = getState().locations;
	let pageNumber = 1;
	let displayCount = 25;

	if (section === 'activeJobs') {
		const { filters } = activeJobs;
		pageNumber = filters.pageNumber;
		displayCount = filters.displayCount;
	} else {
		const { filters } = jobHistory;
		pageNumber = filters.pageNumber;
		displayCount = filters.displayCount;
	}

	dispatch(Actions.setLoading(section, true));

	JobService.getAll({
		asc       : false,
		unStaffed : false,
		status    : section === 'activeJobs' ? 1 : 3,
		pageNumber,
		displayCount,
		locationId,
	})
		.then(({ data }) => {
			dispatch(Actions.receiveSectionData(section, data.ItemList, data.Count));
			dispatch(Actions.setLoading(section, false));
		})
		.catch(apiErrorHandler({
			dispatch,
			module   : 'locations',
			property : 'loading.activeJobs',
		}));
});

export const getOfficers = () => ((dispatch, getState) => {
	const {
		router    : { match : { params : { id : locationId } } },
		locations : {
			details : {
				officers : {
					filters : {
						pageNumber,
						displayCount,
					},
				},
			},
		},
	} = getState();

	dispatch(Actions.setLoading('officers', true));

	LocationService.getOfficers(locationId, {
		pageNumber,
		displayCount,
	}).then(({ data }) => {
		dispatch(Actions.receiveSectionData('officers', data.ItemList, data.Count));
		dispatch(Actions.setLoading('officers', false));
	}).catch(apiErrorHandler({
		dispatch,
		module   : 'locations',
		property : 'loading.officers',
	}));
});

export const getPosts = (reset) => ((dispatch, getState) => {
	// if the user reloads the page the componentWillUmount will not be called
	// so to reset the activity the reset flag is passed
	const {
		router    : { match : { params : { id } } },
		locations : {
			details : {
				activity : {
					data : activityData,
					filters : {
						pagingToken,
						displayCount,
					},
				},
			},
		},
	} = getState();

	dispatch(Actions.setLoading('activity', true));

	LocationService.getPosts({
		id,
		displayCount,
		pagingToken : !reset ? pagingToken : null,
	}).then(({ data }) => {
		const newActivityData = reset ? data.ItemList : activityData.concat(data.ItemList);
		dispatch(Actions.receiveSectionData('activity', newActivityData, data.Count));
		dispatch(Actions.setLoading('activity', false));
		dispatch(Actions.updateSectionFilters('activity', {
			pagingToken : data.PagingToken,
			hasNext     : data.HasNext,
		}));
	}).catch(apiErrorHandler({
		dispatch,
		module   : 'locations',
		property : 'loading.activity',
	}));
});

export default {
	getLocationsData,
	getLocationDetails,
	getMinimalLocationsData,
	getJobsData,
	getOfficers,
	getPosts,
};
